/* eslint-disable react/no-danger */

import PropTypes from "prop-types";
import React from "react";

import DateFormatingService from "services/DateFormatingService";

import { initClevercastContainers } from "components/content-blocks/video";

const escapeHtmlAttribute = (html) =>
  html
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const getVideoHtml = (html) => {
  if (
    html.includes("data-clevercast-video") &&
    !html.includes("data-embed-container")
  ) {
    return `<div class="embed-container embed-container--clevercast" data-embed-container data-html-content="${escapeHtmlAttribute(
      html
    )}"></div>`;
  }

  return html;
};

class VideoSectionVideo extends React.Component {
  videoContainer = React.createRef();

  componentDidMount = () => {
    this.initVideo();
  };

  componentDidUpdate = () => {
    this.initVideo();
  };

  initVideo = () => {
    window.requestAnimationFrame(() => {
      initClevercastContainers(this.videoContainer.current);
    });
  };

  render = () => {
    const { video } = this.props;
    const videoHtml = getVideoHtml(video.video);

    return (
      <div className="video-section__video">
        <div className="card is-highlight is-video">
          <div
            ref={this.videoContainer}
            className="card__video video__player"
            dangerouslySetInnerHTML={{ __html: videoHtml }}
          />
          <div className="card__content">
            <h3 className="card__title">
              <a href={video.url} className="card__title-link">
                {video.title}
              </a>
            </h3>

            <div className="card__meta">
              <span className="card__main main-tag">{video.program}</span>
              <span className="card__date date">
                {DateFormatingService.formatToTimeAndDate(video.date * 1000)}
              </span>
              <a href={video.url} className="card__more">
                Meer info
              </a>
            </div>
            <div className="card__description">{video.description}</div>
            {Object.keys(video.languages).length > 1 && (
              <div className="language-switch">
                <svg
                  className="language-switch__icon"
                  width="16px"
                  height="16px"
                >
                  <use xlinkHref="#globe" />
                </svg>
                <div className="language-switch__title">ook in:</div>

                {Object.keys(video.languages).map((lang) => (
                  <a
                    href={video.languages[lang].url}
                    className={`lang tag ${
                      video.languages[lang].active ? "is-active" : ""
                    }`}
                  >
                    <span className="lang--short tag__text">
                      {video.languages[lang].short}
                    </span>
                    <span className="lang--long tag__text">
                      {video.languages[lang].long}
                    </span>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
}

VideoSectionVideo.propTypes = {
  video: PropTypes.shape({}).isRequired,
};

export default VideoSectionVideo;
